import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              主题索引
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              按主题快速定位你感兴趣的网红圈内容，每个专题持续更新
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {indexItems.slice(0, 4).map((item) => (
              <a
                key={item.id}
                href="#topics"
                className="group flex items-start gap-4 p-5 bg-background-100 hover:bg-primary-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <div className="min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-xs text-foreground-500 line-clamp-2 leading-relaxed">{item.desc}</p>
                  <span className="inline-block mt-2 text-xs text-primary-500 font-medium">{item.count} 篇内容</span>
                </div>
              </a>
            ))}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5 mt-4 md:mt-5">
            {indexItems.slice(4, 7).map((item) => (
              <a
                key={item.id}
                href="#topics"
                className="group flex items-start gap-4 p-5 bg-background-100 hover:bg-primary-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <div className="min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-xs text-foreground-500 line-clamp-2 leading-relaxed">{item.desc}</p>
                  <span className="inline-block mt-2 text-xs text-primary-500 font-medium">{item.count} 篇内容</span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}